import CheckIcon from "@mui/icons-material/Check";
import { Box, Typography } from "@mui/material";

import { Decimal } from "classes/DecimalClasses";

import { i18n } from "services/i18nService";
import { YOUR_PACKAGING_OPTION } from "services/sosInventoryService/upsShipment/schema";

export function UpsServiceRequirementsChecklist(props) {
  const { record } = props;

  const requirements = [
    {
      label: i18n("upsShipment.Requirement.FromAddress"),
      complete:
        record?.fromAddress?.address?.postalCode &&
        record?.fromAddress?.address?.stateProvince,
      show: true,
    },
    {
      label: i18n("upsShipment.Requirement.ToAddress"),
      complete:
        record?.toAddress?.address?.postalCode &&
        record?.toAddress?.address?.stateProvince,
      show: true,
    },
    {
      label: i18n("upsShipment.Requirement.Weight"),
      complete: record?.weight?.gt(Decimal.ZERO),
      show: true,
    },
    {
      label: i18n("upsShipment.Requirement.Dimensions"),
      complete:
        record?.length?.gt(Decimal.ZERO) &&
        record?.height?.gt(Decimal.ZERO) &&
        record?.width?.gt(Decimal.ZERO),
      show: record?.packagingCode === YOUR_PACKAGING_OPTION.id,
    },
    {
      label: i18n("upsShipment.Requirement.UpsAccount"),
      complete: Boolean(record?.upsAccount),
      show: true,
    },
  ];

  return (
    <Box>
      <Typography variant="body1" fontWeight="bold" gutterBottom>
        {i18n("upsShipment.CompleteRequiredFields")}
      </Typography>
      <ul>
        {requirements.map(({ label, complete, show }, index) =>
          show ? (
            <li key={index}>
              <Box
                key={index}
                component="li"
                sx={{
                  display: "flex",
                  marginBottom: 0.25,
                  lineHeight: 1.2,
                  gap: 1,
                }}
              >
                <Typography>{label} </Typography>

                {complete && <CheckIcon color="success" fontSize="small" />}
              </Box>
            </li>
          ) : null
        )}
      </ul>
    </Box>
  );
}
